import { Pipe, PipeTransform, ChangeDetectorRef } from '@angular/core';
import { GlobalTranslateService } from '../../services/globalTranslate/globalTranslate.service';
import { TranslateService } from "@ngx-translate/core";
import {from, Subscription } from 'rxjs'
import { ServiceConfigService } from '@app/services/service-config.service';
@Pipe({
  name: 'globalTranslate',
  pure: false,
  standalone: false
})
export class globalTranslatePipe implements PipeTransform {
  private lastKey: string = '';
  private lastLang: string = '';
  private finalValue: string = '';
  awsTranslateSwitch = false;
  private subscriptions: Subscription[] = [];

  constructor(private globalTranslationService: GlobalTranslateService, public translateService: TranslateService, private cdr: ChangeDetectorRef, private serverConfig: ServiceConfigService,) {
    this.subscriptions.push(
      this.translateService.onTranslationChange.subscribe(() => {
        this.lastKey = '';
        this.lastLang = '';
        try { this.cdr.detectChanges(); } catch(e) {}
      })
    );

    this.subscriptions.push(
      this.translateService.onLangChange.subscribe(() => {
        this.lastKey = '';
        this.lastLang = '';
        try { this.cdr.detectChanges(); } catch(e) {}
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  
  transform(key: any): string{
    // If key is not a string, convert it to a translatable string
    if (key && typeof key !== 'string') {
      // If it's an array, join values with comma
      if (Array.isArray(key)) {
        key = key.join(', ');
      } 
      // If it's an object, extract string values
      else if (typeof key === 'object') {
        const values = Object.values(key).filter(v => typeof v === 'string');
        key = values.join(', ');
      }
        // For other types (boolean, number), convert to string
      else {
        key = String(key);
      }
    }
    
    let selectedLang = sessionStorage.getItem('globalTranslatedLan') && sessionStorage.getItem('globalTranslatedLan') !== 'undefined' ? sessionStorage.getItem('globalTranslatedLan') : null;
    this.awsTranslateSwitch = this.serverConfig.getServerConfig().awsTranslateSwitch;

    // Determine which language to use for ngx-translate
    if(this.awsTranslateSwitch){
      if(selectedLang === 'es'){
        selectedLang = 'sp'
        this.translateService.setDefaultLang('sp');
      }
    }
    const langToUse = (selectedLang === 'sp' || selectedLang === 'en') ? selectedLang : this.translateService.getDefaultLang();
    
    if(!key || (key === this.lastKey && langToUse === this.lastLang)){
      return this.finalValue;
    }
    
    this.lastKey = key;
    this.lastLang = langToUse;

    
    // If AWS translate switch is false, always use ngx-translate
    if(!this.awsTranslateSwitch){
      // Ensure translateService is using the correct language
      if(this.translateService.getDefaultLang() !== langToUse){
        this.translateService.setDefaultLang(langToUse);
      }
      
      this.translateService.get(key).subscribe(translated => {
        this.finalValue = translated;
        this.cdr.markForCheck();
      });
    }
    // If AWS translate switch is true
    else {
      // For English and Spanish, use ngx-translate JSON files
      if(!selectedLang || selectedLang === 'en' || selectedLang === 'sp' || selectedLang === 'es'){
        // Ensure translateService is using the correct language
        if(this.translateService.getDefaultLang() !== langToUse){
          this.translateService.setDefaultLang(langToUse);
        }
        
        this.translateService.get(key).subscribe(translated => {
          this.finalValue = translated;
          this.cdr.markForCheck();
        });
      } 
      // For other languages, use AWS translation
      else {
        this.translateService.get(key).subscribe(translated => {
          const inputToTranslate = (translated === key) ? key : translated;
          from(this.globalTranslationService.translate(inputToTranslate, selectedLang)).subscribe(awsTranslated => {
            this.finalValue = awsTranslated;
            this.cdr.markForCheck();
          });
        });
      }
    }
    
    return this.finalValue;
  }
}
